// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"246":"af3c4789","319":"0b6d0339","435":"7418387d","579":"bb44e9cf","598":"5e66bd23","718":"74f73fce","886":"38b5bfdb","965":"229aa0a8"}[chunkId] + ".css";
};